import React, { useEffect, useRef } from "react";
import "../../assets/Style.css";

const stats = [
    { label: "Year work <br> experience of", target: 4 },
    { label: "Happy <br>clients", target: 137, showPlus: true },
    { label: "Completed <br> projects", target: 255, showPlus: true },
];

export default function ProjectStats() {
    const countersRef = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        countersRef.current.forEach((el, index) => {
                            const { target, showPlus } = stats[index];
                            const updateCounter = () => {
                                const count = +el.innerText.replace('+', '');
                                const increment = target / 100;

                                if (count < target) {
                                    el.innerText = showPlus
                                        ? `${Math.ceil(count + increment)}+`
                                        : Math.ceil(count + increment);
                                    requestAnimationFrame(updateCounter);
                                } else {
                                    el.innerText = showPlus ? `${target}+` : target;
                                }
                            };
                            updateCounter();
                        });

                        // Stop observing once triggered
                        observer.disconnect();
                    }
                });
            },
            { threshold: 0.3 } // Trigger when 30% of the element is visible
        );

        if (countersRef.current[0]) {
            observer.observe(countersRef.current[0].parentElement);
        }

        return () => observer.disconnect();
    }, []);
    return (
        <div className="main-container">
            <div className="stats-container">
                {stats.map((stat, index) => (
                    <div className="stat-item" key={index}>
                        <p
                            className="label-text"
                            dangerouslySetInnerHTML={{ __html: stat.label }}
                        />
                        <p
                            className="count-number"
                            ref={(el) => (countersRef.current[index] = el)}
                        >
                            {stat.showPlus ? "0+" : "0"}
                        </p>
                        <hr className="mobile-divider" />
                    </div>
                ))}
            </div>
        </div>
    );
}
